import buildApiUrl from "./build-api-url";
import { getTokenFromStorage, removeTokenFromStorage, setTokenInStorage } from "../token";

export const loginRequest = async (username, password, remember) => {
    const url = buildApiUrl("/auth");

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            Username: username,
            Password: password,
            Password2: "", // ?
            Remember: remember,
        })
    })
    const body = await response.json();

    if (response.ok && remember) {
        setTokenInStorage({ username, jwt: body.access_token });
    }

    return {
        ok: response.ok,
        jwt: body.access_token || undefined,
        error: body.error || undefined,
    };
}

export const getAuthenticationHeader = (jwt) => {
    let finalJwt = jwt;

    if (!finalJwt) {
        const token = getTokenFromStorage();
        if (token) {
            finalJwt = token.jwt;
        }
    }
    if (finalJwt && finalJwt.jwt) {
        finalJwt = finalJwt.jwt;
    }

    if (!finalJwt) {
        return { };
    }
    return {
        Authorization: "JWT " + finalJwt,
    }
}

export const authenticatedRequest = async (method, endpoint, fetchOptions, token) => {
    const url = buildApiUrl(endpoint); 
    const response = await fetch(url, {
        method: method,
        headers: {
            "Content-Type": "application/json",
            ...getAuthenticationHeader(token),
        },
        ...fetchOptions,
    });

    const body = await response.json();
    return {
        response,
        body,
    };
}

export const verifyTokenRequest = async () => {

    try {
        const token = getTokenFromStorage();

        if (!token) {
            throw new Error();
        }

        // TODO: maybe ping a better path? have to ask for this
        const { response } = await authenticatedRequest("GET", "/list");

        if (!response.ok) {
            removeTokenFromStorage();
        }

        return {
            ok: response.ok,
            username: token.username,
            jwt: token.jwt,
        };
    } catch (e) {
        removeTokenFromStorage();
        return {
            ok: false,
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/api/auth.js